export const actions: any = {
  amenity: 'Amenities',
  building: 'Building Amenities',
  information: 'Aparment Information',
  type: 'Types',
  amenities: 'Amenities',
  types: 'Types',
  filters: 'Building Amenities',
  cuisine: 'Cuisines',
  country: 'Countries',
  meals: 'Meals',
  status: 'Status',
  constructor: 'Constructors',
  breakfast: 'Breakfast',
  hotelAmenity: 'Hotel Amenity',
  parking: 'Parking',
  price: 'Price',
  roomFoodDrinkAmenity: 'Room Food Drink Amenity',
  roomGeneralAmenity: 'Room General Amenity',
  roomOutdoorViewAmenity: 'Room Outdoor View Amenity',
  star: 'Star',
};

export type KeyAc = keyof typeof actions;

export const categories = {
  apartments: 'apartments',
  hotels: 'hotels',
  constructors: 'constructors',
  restaurants: 'restaurants',
};

export const copiaCategories:any = {
  apartments: 'Apartments',
  hotels: 'Hotels',
  constructors: 'Real Estate',
  restaurants: 'Restaurants',
};

export const floorArea = [
  {
    title: '50-100',
    query: {
      floorAreaFrom: '50',
      floorAreaTo: '100',
    },
    selected: false,
  },
  {
    title: '100-150',
    query: {
      floorAreaFrom: '100',
      floorAreaTo: '150',
    },
    selected: false,
  },
  {
    title: '150-250',
    query: {
      floorAreaFrom: '150',
      floorAreaTo: '250',
    },
    selected: false,
  },
  {
    title: '250-*',
    query: {
      floorAreaFrom: '250',
      floorAreaTo: '400',
    },
    selected: false,
  },
];

export const floor = [
  {
    title: 'From',
    key: 'floorFrom',
    value: '',
  },
  {
    title: 'To',
    key: 'floorTo',
    value: '',
  },
];

export const roomsCount = [
  {
    title: 1,
    id: 1,
    key: 'roomsCount',
    selected: false,
  },
  {
    title: 2,
    id: 2,
    key: 'roomsCount',
    selected: false,
  },
  {
    title: 3,
    id: 3,
    key: 'roomsCount',
    selected: false,
  },
  {
    title: 4,
    id: 4,
    key: 'roomsCount',
    selected: false,
  },
  {
    title: 5,
    id: 5,
    key: 'roomsCount',
    selected: false,
  },
  {
    title: 6,
    id: 6,
    key: 'roomsCount',
    selected: false,
  },
  {
    title: '7+',
    id: '7+',
    key: 'roomsCount',
    selected: false,
  },
];
